/**
 * toast.js — shared toast notification component
 * =================================================
 *
 * 2026-09-17: pulled out of referral-attribution.js's one-off
 * showSelfReferralToast() (own inline-styled div, bottom-center,
 * dismiss-on-click-or-8s) into a small reusable module, so the rewards
 * page's redeem flow and the cart-drawer's redeem flow can both raise a
 * "reward applied" confirmation without duplicating that styling a third
 * and fourth time. referral-attribution.js is intentionally left as-is
 * (still ships its own copy) since it isn't part of this change.
 *
 * Usage:
 *   window.EnrichmentToast.show('Message here');
 *   window.EnrichmentToast.show('Reward applied to your cart.', { tone: 'success' });
 *
 * Options:
 *   tone     'default' (brand green, #183029) | 'success' (adds a check
 *            mark) -- both currently render on the same dark background;
 *            'success' exists as a hook for callers, not a visual split.
 *   duration ms before auto-dismiss (default 5000).
 *
 * Multiple toasts stack (each is its own fixed-position element with a
 * bottom offset based on how many are already showing), rather than one
 * replacing another -- a redeem confirmation shouldn't swallow a
 * differently-timed message.
 */
(function () {
  'use strict';

  var activeToasts = [];

  function reposition() {
    var offset = 2.4;
    activeToasts.forEach(function (toast) {
      toast.style.bottom = offset + 'rem';
      offset += toast.offsetHeight / 10 + 1.2; // rough rem conversion, good enough for stacking
    });
  }

  function show(message, options) {
    options = options || {};
    var duration = typeof options.duration === 'number' ? options.duration : 5000;

    var toast = document.createElement('div');
    toast.className = 'enrichment-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    if (options.tone === 'success') {
      var check = document.createElement('span');
      check.className = 'enrichment-toast__icon';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';
      toast.appendChild(check);
    }

    var text = document.createElement('span');
    text.textContent = message;
    toast.appendChild(text);

    function remove() {
      var index = activeToasts.indexOf(toast);
      if (index !== -1) activeToasts.splice(index, 1);
      toast.remove();
      reposition();
    }

    toast.addEventListener('click', remove);
    document.body.appendChild(toast);
    activeToasts.push(toast);
    reposition();

    setTimeout(remove, duration);

    return remove;
  }

  window.EnrichmentToast = { show: show };
})();
